import { Table, TableContainer, useTheme } from '@mui/material';
import React from 'react';

interface ICustomTableProps {
    size?: 'small' | 'medium';
    children: React.ReactNode | React.ReactNode[];
    stickyHeader?: boolean;
    padding?: boolean;
    // Bounds the container's height so IT becomes the vertical scroller. Without
    // it the container grows to content height and the page scrolls instead —
    // which leaves `stickyHeader` with nothing to stick to. Pass a value (e.g.
    // 'calc(100vh - 240px)') on long, unpaginated tables that want a sticky head.
    maxHeight?: number | string;
    // Make the container a flex child that fills its parent (flex:1, minHeight:0)
    // and scrolls internally. Use when the table lives in a bounded flex column
    // and should be the ONLY vertical scroller (sticky header, no page scroll).
    fill?: boolean;
}

export function DTable({
    size = 'small',
    stickyHeader = true,
    children,
    padding = true,
    maxHeight,
    fill = false,
}: ICustomTableProps) {
    const theme = useTheme();
    return (
        <TableContainer
            sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: '5px',
                ...(fill ? { flex: 1, minHeight: 0 } : {}),
                ...(maxHeight !== undefined ? { maxHeight } : {}),
            }}
        >
            <Table
                size={size}
                stickyHeader={stickyHeader}
                padding={padding ? 'normal' : 'none'}
                sx={{
                    '&  td': {
                        padding: '0 4px',
                    },
                }}
            >
                {children}
            </Table>
        </TableContainer>
    );
}
